import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      // const session = await authApi.login({ username, password });
      // setSession(session);
      navigate("/dashboard");
    } catch {
      setError(
        "That username or password did not work. Ask a grown-up for help!",
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-indigo-500 p-6">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm rounded-3xl bg-white p-8 shadow-xl"
      >
        <h1 className="mb-6 text-center text-2xl font-extrabold text-indigo-600">
          Learning Adventures
        </h1>
        <label className="mb-1 block text-sm font-bold text-slate-600">
          Username
        </label>
        <input
          className="mb-4 w-full rounded-xl border-2 border-slate-200 p-3 text-lg"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
        />
        <label className="mb-1 block text-sm font-bold text-slate-600">
          Password
        </label>
        <input
          type="password"
          className="mb-4 w-full rounded-xl border-2 border-slate-200 p-3 text-lg"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />
        {error && (
          <p className="mb-3 text-sm font-bold text-red-500">{error}</p>
        )}
        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-full bg-amber-400 py-3 text-lg font-extrabold text-slate-900 disabled:opacity-60"
        >
          {loading ? "Logging in..." : "Start Learning"}
        </button>
      </form>
    </div>
  );
}
